import { RootState } from '@redux/store';
import { createSelector } from '@reduxjs/toolkit';
import { selectParameter } from '@utils/common.utils';

import { Contact } from '@/types/chat/chat.types';

import { contactsAdapter, messagesAdapter } from './chat.adapters';
import { ChatState } from './chat.reducer';

function selectChatState(state: RootState): ChatState {
  return state.chat;
}

const { selectAll: selectAllContacts } = contactsAdapter.getSelectors((state: RootState) => state.chat.contacts);

export const selectAllContactsByPlatform = createSelector(
  [selectAllContacts, selectParameter<string | undefined>],
  (contacts, platformCode): Contact[] =>
    platformCode ? contacts.filter((contact) => contact.platform === platformCode) : [],
);

const { selectAll: selectAllMessages } = messagesAdapter.getSelectors((state: RootState) => state.chat.messages);

export const MessagesSelectors = {
  selectAllMessages,
};

export const selectNewMessageEntry = createSelector(selectChatState, (state: ChatState) => state.newMessageEntry);
